<!--
 * @Description: 外协单位阶结算
 * @Author: wangwangwang
 * @Date: 2020-11-18 15:34:16
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-01-09 11:54:57
-->
<template>
  <div class="flows-content">
    <el-container>
      <el-main style="margin-bottom: 20px; padding: 0">
        <el-container direction="vertical">
          <FlowHeader
            :isReadOnly="readOnly"
            @saveSubmit="handleSubmit(1)"
            @sendSubmit="handleSubmit(2)"
            @handleBackEnd="handleSubmit(3)"
            @handleCC="handleSubmit(4)"
            @handleAssign="handleSubmit(5)"
            @handleBackUp="handleSubmit(6)"
            @handleAssist="handleSubmit(7)"
            @handleNode="handleSubmit(8)"
            @handleNodeImage="handleSubmit(9)"
            @handleCollection="handleSubmit(10)"
          />
          <el-main class="info">
            <div>
              <el-input v-model="title" class="flow-title" :disabled="$route.query.type * 1 !== 1" placeholder="请输入流程标题"></el-input>
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{ billCode }}</span>
                <span class="text">制单日期：{{ billDate }}</span>
              </div>
              <div class="right">
                <span>发起人：{{ applyPerson }}</span>
                <span class="text">状态：{{ taskTypeText[taskStatus * 1] }}</span>
              </div>
            </div>
            <!-- 结算单内容 -->
            <div class="bill_title1">{{ statementsType !== 4 ? "产品费用：" : "产品数据：" }}</div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.hunPrice" tooltip-effect="dark" :span-method="hunPriceObjectSpanMethod">
              <el-table-column v-if="statementsType !== 4" label="时间段" align="center" prop="">
                <template slot-scope="scope">
                  <span>{{ scope.row.startSettleTime + "-" + scope.row.endSettleTime }}</span>
                </template>
              </el-table-column>
              <el-table-column label="产品名称" align="center" prop="productName"></el-table-column>
              <el-table-column label="签收数量（方）" align="center" prop="signForNum"></el-table-column>
              <el-table-column v-if="statementsType !== 4" label="产品组合" align="center" prop="splitProductStr"> </el-table-column>
              <el-table-column v-if="statementsType !== 4" label="单价（元/m³）" align="center" prop="splitProductPriceStr"> </el-table-column>
              <el-table-column v-if="statementsType !== 4" label="强度等级单价（元/m³）" align="center" prop="strengthPrice"> </el-table-column>
              <el-table-column v-if="statementsType !== 4" label="特添材料单价（元/m³）" align="center" prop="specialPrice"> </el-table-column>
              <el-table-column v-if="statementsType !== 4" label="结算单价 (元)" align="center" prop="settlementPrice"></el-table-column>
              <el-table-column v-if="statementsType !== 4" label="结算金额（元）" align="center">
                <template slot-scope="scope">
                  {{ (scope.row.settlementMoney = Number(Number(scope.row.signForNum || 0) * Number(scope.row.settlementPrice || 0)).toFixed(2)) }}
                </template>
              </el-table-column>
            </el-table>
            <div v-if="billList.hunPrice.length !== 0 && statementsType !== 4" class="combined">小计：结算金额【{{ combined(billList.hunPrice) }}】</div>
            <el-table
              v-if="statementsType !== 3 && statementsType !== 4"
              :header-cell-style="{ background: '#f3f6f9' }"
              :cell-style="{ borderRight: 'none' }"
              border
              stripe
              style="width: 100%"
              :data="billList.splitPrice"
              tooltip-effect="dark"
            >
              <el-table-column label="原材料" align="center" prop="rawName"></el-table-column>
              <el-table-column label="供应商" align="center" prop="supperName"></el-table-column>
              <el-table-column v-if="statementsType == 1" label="拆分金额（元）" align="center" prop="splitMoney"> </el-table-column>
              <el-table-column v-if="statementsType == 1" label="数量" align="center" prop="splitNum"></el-table-column>
              <el-table-column v-if="statementsType == 1" label="配合比" align="center" prop="mixProportion"></el-table-column>
              <el-table-column label="单价" align="center" prop="price"></el-table-column>
              <el-table-column v-if="statementsType == 2" label="数量" align="center" prop="splitNum"> </el-table-column>
              <el-table-column label="状态" align="center" prop="settlementStatus">
                <template slot-scope="scope">
                  {{ scope.row.settlementStatus == 2 ? "已结算" : "结算中" }}
                </template>
              </el-table-column>
            </el-table>
            <el-table v-if="statementsType == 4" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.splitPrice" tooltip-effect="dark">
              <el-table-column label="原材料" align="center" prop="rawName"> </el-table-column>
              <el-table-column label="数量" align="center" prop="splitNum"> </el-table-column>
            </el-table>
            <div class="bill_title1">泵送费用：</div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.pumpPrice" tooltip-effect="dark">
              <el-table-column label="泵类型" align="center" prop="signForNum"></el-table-column>
              <el-table-column label="泵送方量(方)" align="center" prop="signForNum"></el-table-column>
              <el-table-column label="补差方量(方)" align="center" prop="pumpSupplementNum"></el-table-column>
              <el-table-column label="基本单价（元/方）" align="center" prop="price"></el-table-column>
              <el-table-column label="结算单价（元）" align="center" prop="settlementPrice"> </el-table-column>
              <el-table-column label="结算金额（元）" align="center" prop="">
                <template slot-scope="scope">
                  {{ (scope.row.settlementMoney = Number(Number(scope.row.signForNum) * Number(scope.row.settlementPrice)).toFixed(2)) }}
                </template>
              </el-table-column>
            </el-table>
            <div v-if="billList.pumpPrice.length !== 0" class="combined">小计：结算金额【{{ combined(billList.pumpPrice) }}】</div>
            <div class="bill_title1">泵送协助补差：</div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="[billList.assistPumpPrice]" tooltip-effect="dark">
              <el-table-column label="协助泵送方量（方）" align="center" prop="signForNum"></el-table-column>
              <el-table-column label="协助单价（元/方）" align="center" prop="settlementPrice"></el-table-column>
              <el-table-column label="泵送协助结算金额（元）" align="center" prop="">
                <template slot-scope="scope">
                  {{ (scope.row.settlementMoney = Number(Number(scope.row.signForNum) * Number(scope.row.settlementPrice)).toFixed(2)) }}
                </template>
              </el-table-column>
            </el-table>
            <div class="bill_title1">特殊运载费用：</div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.specialTran" tooltip-effect="dark">
              <el-table-column label="浇筑方式" align="center" prop="pumpCarName"></el-table-column>
              <el-table-column label="方量（方）" align="center" prop="signForNum"></el-table-column>
              <el-table-column label="结算单价（元/方）" align="center" prop="settlementPrice"></el-table-column>
              <el-table-column label="结算金额（元）" align="center" prop="settlementMoney"> </el-table-column>
            </el-table>
            <div v-if="billList.specialTran.length !== 0" class="combined">小计：结算金额【{{ combined(billList.specialTran) }}】</div>
            <div class="bill_title1">超高层增加费：</div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.highOverPrice" tooltip-effect="dark">
              <el-table-column label="高度（米）" align="center" prop="highArea"></el-table-column>
              <el-table-column label="超高层方量（方）" align="center" prop="signForNum"></el-table-column>
              <el-table-column label="含税增加费（元/方）" align="center" prop="price"></el-table-column>
              <el-table-column label="结算单价（元）" align="center" prop="settlementPrice"> </el-table-column>
              <el-table-column label="结算金额（元）" align="center" prop="">
                <template slot-scope="scope">
                  {{ (scope.row.settlementMoney = Number(Number(scope.row.signForNum) * Number(scope.row.settlementPrice)).toFixed(2)) }}
                </template>
              </el-table-column>
            </el-table>
            <div v-if="billList.highOverPrice.length !== 0" class="combined">小计：结算金额【{{ combined(billList.highOverPrice) }}】</div>
            <div class="bill_title1">运输费用：</div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.yunPrice" tooltip-effect="dark">
              <el-table-column label="运距（km）" align="center" prop="transportArea"></el-table-column>
              <el-table-column label="运输方量(方)" align="center" prop="signForNum"></el-table-column>
              <el-table-column label="基本单价（元/方）" align="center" prop="price">
                <template slot-scope="scope">
                  <span v-if="scope.row.addTransportRule">{{ scope.row.addTransportRule }}</span>
                  <span v-else>{{ scope.row.price }}</span>
                </template>
              </el-table-column>
              <el-table-column label="结算单价（元）" align="center" prop="settlementPrice"></el-table-column>
              <el-table-column label="结算金额（元）" align="center" prop="settlementMoney"></el-table-column>
            </el-table>
            <div v-if="billList.yunPrice.length !== 0" class="combined">小计：结算金额【{{ combined(billList.yunPrice) }}】</div>
            <div class="bill_title1">运输协助补差：</div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="[billList.assistTransportPrice]" tooltip-effect="dark">
              <el-table-column label="运输协助方量（方）" align="center" prop="signForNum"></el-table-column>
              <el-table-column label="协助单价（元/方）" align="center" prop="settlementPrice"></el-table-column>
              <el-table-column label="运输协助结算金额（元）" align="center" prop="">
                <template slot-scope="scope">
                  {{ (scope.row.settlementMoney = Number(Number(scope.row.signForNum) * Number(scope.row.settlementPrice)).toFixed(2)) }}
                </template>
              </el-table-column>
            </el-table>
            <div v-if="billList.supplyCarPrice">
              <div class="bill_title1">运输费用（车补）：</div>
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="[billList.supplyCarPrice]" tooltip-effect="dark">
                <el-table-column label="单价（元/车）" align="center" prop="settlementPrice"></el-table-column>
                <el-table-column label="数量（车）" align="center" prop="signForNum"></el-table-column>
                <el-table-column label="结算金额（元）" align="center" prop="">
                  <template slot-scope="scope">
                    {{ (scope.row.settlementMoney = Number(Number(scope.row.signForNum) * Number(scope.row.settlementPrice)).toFixed(2)) }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div v-if="!billList.supplyCarPrice">
              <div class="bill_title1">运输费用（方补）：</div>
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.supplyNumPrice" tooltip-effect="dark">
                <el-table-column label="运距（km）" align="center" prop="transportArea"></el-table-column>
                <el-table-column label="运输方量(方)" align="center" prop="signForNum"></el-table-column>
                <el-table-column label="补差单价（元/方）" align="center" prop="price">
                  <template slot-scope="scope">
                    <span v-if="scope.row.addTransportRule">{{ scope.row.addTransportRule }}</span>
                    <span v-else>{{ scope.row.price }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="结算金额（元）" align="center" prop="settlementMoney"> </el-table-column>
              </el-table>
              <div v-if="billList.supplyNumPrice.length !== 0" class="combined">小计：结算金额【{{ combined(billList.supplyNumPrice) }}】</div>
            </div>
            <div class="bill_title1">混凝土加工费用：</div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.jiaPrice" tooltip-effect="dark">
              <el-table-column label="站点" align="center" prop="productName"></el-table-column>
              <el-table-column label="加工方量（方）" align="center" prop="signForNum"></el-table-column>
              <el-table-column label="加工价（元/方）" align="center" prop="settlementPrice"></el-table-column>
              <el-table-column label="结算金额（元）" align="center" prop="settlementMoney"></el-table-column>
            </el-table>
            <div v-if="billList.jiaPrice.length !== 0" class="combined">小计：结算金额【{{ combined(billList.jiaPrice) }}】</div>
            <div class="bill_title1">特殊条款：</div>
            <div>{{ billList.specialItems }}</div>
            <!-- 结算补差 -->
            <div class="bill_title">结算补差</div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="billList.compenList" tooltip-effect="dark" :span-method="sendersSpanMethod">
              <el-table-column label="时间段" align="center">
                <template slot-scope="scope">
                  {{ scope.row.startSettleTime + "-" + scope.row.endSettleTime }}
                </template>
              </el-table-column>
              <el-table-column label="产品名称" align="center" prop="rawName"></el-table-column>
              <el-table-column label="签收数量（方）" align="center" prop="signForNum"> </el-table-column>
              <el-table-column label="原结算单价（元/m³）" align="center" prop="settlementPrice"> </el-table-column>
              <el-table-column label="补差单价（元/m³）" align="center" prop="price"> </el-table-column>
              <el-table-column label="结算补差金额（元）" align="center" prop="settlementMoney"> </el-table-column>
            </el-table>
            <div style="border-top: 0px" class="combined">小计：签收数量{{ combined4().signForNum }}，结算补差金额{{ combined4().settlementMoney }}</div>
            <!-- 调整金额 -->
            <div class="bill_title">调整金额</div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="deductionList" tooltip-effect="dark">
              <el-table-column label="调整类型" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.adjustModule == 1">产品费用</span>
                  <span v-if="scope.row.adjustModule == 2">泵送费用</span>
                  <span v-if="scope.row.adjustModule == 3">运输费用</span>
                  <span v-if="scope.row.adjustModule == 4">混凝土加工费用</span>
                </template>
              </el-table-column>
              <el-table-column label="调增调减" align="center" prop="type">
                <template slot-scope="scope">
                  <span v-if="scope.row.type == 1">调增</span>
                  <span v-if="scope.row.type == 0">调减</span>
                </template>
              </el-table-column>
              <el-table-column label="调整金额" align="center" prop="isInvoice"> </el-table-column>
              <el-table-column label="是否影响开票" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.isInvoice == 1">是</span>
                  <span v-if="scope.row.isInvoice == 0">否</span>
                </template>
              </el-table-column>
              <el-table-column label="备注" align="center" prop="remark"> </el-table-column>
            </el-table>
            <div class="bill_title">主合同单位结算合计：</div>
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="totalList" tooltip-effect="dark">
              <el-table-column label="外协单位" align="center" prop="supperName"> </el-table-column>
              <el-table-column label="合同签订主体" align="center" prop="contractSigningSubject"> </el-table-column>
              <el-table-column v-if="statementsType == 3" label="产品费用" align="center" prop="productMoney"> </el-table-column>
              <el-table-column label="运输费用" align="center" prop="transportMoney"> </el-table-column>
              <el-table-column label="泵送费用" align="center" prop="pumpMoney"> </el-table-column>
              <el-table-column label="特殊运载费用" align="center" prop="specialTransportMoney"> </el-table-column>
              <el-table-column label="超高层费用" align="center" prop="highOverMoney"> </el-table-column>
              <el-table-column label="混凝土加工费用" align="center" prop="machineMoney"> </el-table-column>
              <el-table-column label="调整费用" align="center" prop="adjustMoney"> </el-table-column>
              <el-table-column label="影响开票调整金额 (元)" align="center" prop="isAdjustMoney"> </el-table-column>
              <el-table-column label="不影响开票调整金额 (元)" align="center" prop="noAdjustMoney"> </el-table-column>
              <el-table-column label="结算金额 (元)" align="center" prop="settleMoney"> </el-table-column>
              <el-table-column label="开票金额(元)" align="center" prop="invoiceMoney"> </el-table-column>
            </el-table>
            <div v-if="statementsType !== 3 && statementsType !== 4" class="bill_title">结算合计：</div>
            <el-table
              v-if="statementsType !== 3 && statementsType !== 4"
              :header-cell-style="{ background: '#f3f6f9' }"
              :cell-style="{ borderRight: 'none' }"
              border
              stripe
              style="width: 100%"
              :data="allTotalList"
              tooltip-effect="dark"
            >
              <el-table-column label="外协单位" align="center" prop="supperName"> </el-table-column>
              <el-table-column label="结算金额 (元)" align="center" prop="settleMoney"> </el-table-column>
              <el-table-column label="开票金额(元)" align="center" prop="invoiceMoney"> </el-table-column>
              <el-table-column label="状态" align="center" prop="settlementStatus">
                <template slot-scope="scope">
                  {{ scope.row.settlementStatus == 2 ? "已结算" : "结算中" }}
                </template>
              </el-table-column>
            </el-table>
            <div v-if="statementsType !== 3 && statementsType !== 4" class="combined">小计：结算金额【{{ combinedsettleMoney(allTotalList) }}】</div>
            <div class="flows-details">
              <FlowContent ref="flowcontent" :title="title" :showSendVisible="showSendVisible" @handleCancel="handleCancel" @sendCode="sendCode" @handleFinish="handleFinish" @handleBusiness="handleBusiness" />
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import FlowContent from "@/components/WorkFlow/flowContent";
import FlowHeader from "@/components/WorkFlow/flowHeader";
import { getUserInfo } from "@/utils/auth.js";
import { selectSettleDetail, updateFinalStatementStatus } from "@/api/wise/Wise_contactsbusiness/Wise_contactsbusiness.js";
export default {
  components: {
    FlowContent,
    FlowHeader,
  },
  data() {
    return {
      type: 0,
      title: "外协单位结算",
      billCode: "",
      billDate: "",
      applyPerson: "",
      taskTypeText: ["发起", "已保存", "审批中", "已完成", "撤销", "不通过"],
      taskStatus: 0,
      readOnly: false,
      showSendVisible: false,
      billList: {
        jiaPrice: [],
        pumpPrice: [],
        specialTran: [],
        assistPumpPrice: [],
        highOverPrice: [],
        yunPrice: [],
        assistTransportPrice: [],
        supplyCarPrice: [],
        supplyNumPrice: [],
        hunPrice: [],
        splitPrice: [],
        settlementInfo: {},
      },
      totalList: [
        {
          id: "",
          supperName: "",
          betonMoney: 0,
          transportMoney: 0,
          pumpMoney: 0,
          specialTransportMoney: 0,
          machineMoney: 0,
          adjustMoney: 0,
          isAdjustMoney: 0,
          noAdjustMoney: 0,
          settlementMoney: 0,
          invoiceMoney: 0,
          settleType: 1,
          settlementStatus: "",
        },
      ],
      titlestatus: null,
      statementsType: 1,
      billDetails1: [],
      deductionList: [],
      allTotalList: [],
      spanArr:{},
      pos:0,
    };
  },
  methods: {
    combined4() {
      let num = 0;
      let num2 = 0;
      this.billList.compenList.forEach(res => {
        num = Number(res.settlementMoney) + num;
        num2 = Number(res.signForNum) + num2;
      });
      return { settlementMoney: num, signForNum: num2 };
    },
    sendersSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        const _row = this.spanArr[row.startSettleTime + "time" + row.endSettleTime][rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex == 1) {
        const _row = this.spanArr[row.rawName][rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    getSpanArr(data) {
      if (data.length == 0) {
        return;
      }
      console.log("zmmm--", data); //从后台获取的数据
      this.spanArr = {};
      this.pos = 0;
      data.forEach((items, indexs) => {
        if (indexs === 0) {
          // 如果是第一条记录（即索引是0的时候），向数组中加入１
          this.spanArr[items.rawName] = [];
          this.spanArr[items.rawName].push(1);
          this.pos = 0;
        } else {
          if (items.rawName === data[indexs - 1].rawName) {
            // 如果itemCode相等就累加，并且push 0
            this.spanArr[items.rawName][this.pos] += 1;
            this.spanArr[items.rawName].push(0);
          } else {
            // 不相等push 1
            let same = false;
            Object.keys(this.spanArr).forEach(spanItem => {
              if (spanItem == items.rawName) {
                same = true;
              }
            });
            if (!same) {
              this.spanArr[items.rawName] = [];
            }
            this.spanArr[items.rawName][indexs] = 1;
            this.pos = indexs;
          }
        }
      });
      data.forEach((items, indexs) => {
        let key = items.startSettleTime + "time" + items.endSettleTime;
        if (indexs === 0) {
          // 如果是第一条记录（即索引是0的时候），向数组中加入１
          this.spanArr[key] = [];
          this.spanArr[key].push(1);
          this.pos = 0;
        } else {
          if (items.startSettleTime === data[indexs - 1].startSettleTime && items.endSettleTime === data[indexs - 1].endSettleTime) {
            // 如果itemCode相等就累加，并且push 0
            this.spanArr[key][this.pos] += 1;
            this.spanArr[key].push(0);
          } else {
            // 不相等push 1
            let same = false;
            Object.keys(this.spanArr).forEach(spanItem => {
              if (spanItem == key) {
                same = true;
              }
            });
            if (!same) {
              this.spanArr[key] = [];
            }
            // this.spanArr[items.receiveStationId].push(1);
            this.spanArr[key][indexs] = 1;
            this.pos = indexs;
          }
        }
      });
      console.log(this.spanArr);
    },
    hunPriceObjectSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex === 0 && this.statementsType !== 4) {
        // 获取当前单元格的值
        const currentValue = row["informationPeriodStartTime"] + "-" + row["informationPeriodEndTime"];
        // 获取上一行相同列的值
        const preRow = this.billList.hunPrice[rowIndex - 1];
        const preValue = preRow ? preRow["informationPeriodStartTime"] + "-" + preRow["informationPeriodEndTime"] : null;
        // 如果当前值和上一行的值相同，则将当前单元格隐藏
        if (currentValue === preValue) {
          return { rowspan: 0, colspan: 0 };
        } else {
          // 否则计算当前单元格应该跨越多少行
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.billList.hunPrice.length; i++) {
            const nextRow = this.billList.hunPrice[i];
            const nextValue = nextRow["informationPeriodStartTime"] + "-" + nextRow["informationPeriodEndTime"];
            if (nextValue === currentValue) {
              rowspan++;
            } else {
              break;
            }
          }
          return { rowspan, colspan: 1 };
        }
      }
    },
    /**结算信息合计*/
    combinedsettleMoney(arr) {
      let num = 0;
      if (arr.length > 0) {
        arr.forEach(res => {
          num = Number(res.settleMoney || 0) + num;
        });
      }
      return num.toFixed(2);
    },
    handleBusiness() {
      const { query } = this.$route;
      const params = {
        process_success: {
          url: "/icps/system/sign/intelligent/proDispatchLogistics/updateFinalStatementStatus",
          data: {
            id: JSON.parse(query.dataContent).id,
            auditStatus: 3,
          },
          httpMethod: "post",
        },
        process_failure: {
          url: "/icps/system/sign/intelligent/proDispatchLogistics/updateFinalStatementStatus",
          data: {
            id: JSON.parse(query.dataContent).id,
            auditStatus: 4,
          },
          httpMethod: "post",
        },
      };
      this.showSendVisible = false;
      this.$refs.flowcontent.handleToFlow(params);
    },
    /**
     * @Description:
     * @Param: 1为保存，2为最后提交
     * @Author: wangwangwang
     * @param {*} type
     */
    handleFinish(type) {
      const { query } = this.$route;
      if (type == 1) {
        updateFinalStatementStatus({
          id: query.id,
          auditStatus: 2,
        });
      }
    },
    handleSubmit(type) {
      const { query } = this.$route;
      if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) {
        // 发起流程
        this.showSendVisible = true;
        return;
      }
      const data = {
        dataSource: "sign_Wise_contactsbusiness1",
        dataContent: JSON.stringify({ id: query.id }), // 业务数据
      };
      this.$refs.flowcontent.saveFlows(type, data);
    },
    handleFlowChat() {
      this.$refs.flowcontent.showFlowNode();
    },
    handleCancel() {
      this.showSendVisible = false;
    },
    /**
     * @Description: 回显业务数据
     * @Param:
     * @Author: wangwangwang
     */
    initFlowsData(id) {
      let _this = this;
      selectSettleDetail({ id: id }).then(res => {
        if (res.code == 1001) {
          if (res.data.settlementInfo.contractType == 1) {
            this.statementsType = 3;
          }
          if (res.data.settlementInfo.contractType == 2 && res.data.settlementInfo.contractMethod == 1) {
            this.statementsType = 1;
          }
          if (res.data.settlementInfo.contractType == 2 && res.data.settlementInfo.contractMethod == 2) {
            this.statementsType = 2;
          }
          if (res.data.settlementInfo.contractType == 2 && res.data.settlementInfo.contractMethod == 3) {
            this.statementsType = 4;
          }
          _this.billList = res.data;
          //给拆分数据增加结算状态
          _this.billList.splitPrice?.forEach((item, index) => {
            item.settlementStatus = item.isSettle ? "2" : "1";
            item.invoiceMoney = res.data.rawTotalPrice.length > 0 ? res.data.rawTotalPrice[index].invoiceMoney : 0;
            item.settleMoney = res.data.rawTotalPrice.length > 0 ? res.data.rawTotalPrice[index].settleMoney : 0;
          });
          _this.billDetails = [];
          _this.billDetails1.supplierName = res.data.settlementInfo.supplierName;
          _this.billDetails1.supplierId = res.data.settlementInfo.supplierId;
          _this.billDetails1.outsourcingUnit = res.data.settlementInfo.supplierName;
          _this.billDetails1.outsourcingUnitId = res.data.settlementInfo.supplierId;
          _this.billDetails1.settlementPeriod = res.data.settlementInfo.settlementPeriod;
          _this.billDetails1.balanceNo = res.data.settlementInfo.balanceNo;
          _this.billCode = res.data.settlementInfo.balanceNo;
          _this.billDate = res.data.settlementInfo.createTime;
          _this.deductionList = JSON.parse(JSON.stringify(res.data.adjustPrice));
          this.getSpanArr(_this.billList.compenList);
          _this.totalList = JSON.parse(JSON.stringify(res.data.mainSupperPrice));
          _this.allTotalList = [..._this.totalList, ..._this.billList.splitPrice];
        }
      });
      const { query } = this.$route;
      if (query.type * 1 !== 1) {
        this.title = query.taskName;
      }
      this.billCode = query.receiptNumber;
      this.billDate = query.createTime;
    },
    /**结算信息合计*/
    combined(arr) {
      let num = 0;
      arr.forEach(res => {
        num = Number(res.settlementMoney) + num;
      });
      return num.toFixed(2);
    },
    /**结算信息合计*/
    combined1(index) {
      let num = 0;
      this.billList[index].forEach(res => {
        num = Number(res.settlementMoney) + num;
      });
      return num;
    },
    sendCode(code) {
      this.billCode = code;
    },
  },
  created() {
    const { query } = this.$route;
    this.titlestatus = Number(query.type);
  },
  mounted() {
    const { query } = this.$route;
    if (query.type * 1 === 1) {
      // 发起流程
      this.initFlowsData(query.id);
      this.$refs.flowcontent.initBaseData("sign_Wise_contactsbusiness1");
      this.billDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
      this.applyPerson = getUserInfo().userRealName;
      return;
    }
    this.initFlowsData(JSON.parse(query.dataContent).id);
    this.applyPerson = query.createUserName;
    this.taskStatus = query.taskStatus;
    if (query.isReadOnly * 1 === 1) {
      this.readOnly = true;
    }
  },
};
</script>
<style lang="scss" scoped>
.bill_title {
  font-size: 18px;
  font-weight: 600;
  padding: 15px 0;
}
.bill_title1 {
  font-size: 18px;
  font-weight: 600;
  padding: 20px 0;
}
.bill_subtitle {
  padding: 20px 0;
  > span {
    padding-right: 20px;
  }
  .text {
    color: #000;
  }
}
.combined {
  border: 1px solid #ebeef5;
  text-align: center;
  line-height: 40px;
}
.flows-details {
  margin-top: 20px;
}
.info {
  padding: 0 20px;
  background: #fff;
  .info-top {
    font-size: $font_size;
    color: #000000;
    @include discen_al;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px #e1e5ed solid;
    .left {
      @include discen_al;
    }
    .text {
      margin-left: 100px;
    }
  }
}
.nav_title {
  @include discen_al;
  align-items: flex-end;
  > div {
    width: 4px;
    height: 24px;
    background: $bg_color;
    margin-right: 10px;
  }
  i {
    margin-left: 5px;
  }
  color: $bg_color;
  font-size: 20px;
  font-weight: bold;
}
.dialoginfo {
  padding: 0;
}
.active {
  border-top: 1px #e1e5ed solid;
  border-right: 1px #e1e5ed solid;
  border-left: 1px #e1e5ed solid;
  background: #fff;
}
.dialoginfo-info {
  border-right: 1px #e1e5ed solid;
  border-left: 1px #e1e5ed solid;
  border-bottom: 1px #e1e5ed solid;
}
/*弹窗*/
.dialoginfo-title {
  > div {
    cursor: pointer;
  }
  height: 48px;
  display: flex;
  background: linear-gradient(180deg, rgba(250, 252, 255, 1) 0%, rgba(245, 247, 250, 1) 100%);
  .none {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(calc(100% - 1px) / 2);
    border-bottom: 1px solid #e1e5ed;
    > div {
      line-height: 48px;
      border-bottom: 1px rgba(0, 0, 0, 0) solid;
    }
  }
  .center {
    width: 1px;
    height: 48px;
    background: #e1e5ed;
  }
  .active {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(calc(100% - 1px) / 2);
    border-bottom: 1px solid rgba(0, 0, 0, 0);
    > div {
      color: $bg_color;
      line-height: 48px;
      border-bottom: 1px $bg_color solid;
    }
  }
}
.dialoginfo-info {
  padding: 10px 20px;
  overflow: auto;
  height: calc(85vh - 282px);
  .el-select,
  .el-input,
  .el-date-picker {
    width: 100%;
  }
}
.form-title {
  font-size: 18px;
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
}
</style>